export default __webpack_public_path__ + "assets/png/4a32f6a27dbd68172a6fc35cdf068d31.png";